import { render, staticRenderFns } from "./BoxPlots.vue?vue&type=template&id=7a0d23b8&scoped=true"
import script from "./BoxPlots.vue?vue&type=script&lang=js"
export * from "./BoxPlots.vue?vue&type=script&lang=js"
import style0 from "./BoxPlots.vue?vue&type=style&index=0&id=7a0d23b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d23b8",
  null
  
)

export default component.exports